import { createFileRoute, redirect } from '@tanstack/react-router';
import { defaultAbateParams } from './-RelatorioTransacoesPage';

export const Route = createFileRoute('/_authenticated/relatorio-transacoes/')({
  beforeLoad: () => {
    return redirect({
      to: '/relatorio-transacoes/$tipo/$ano/$mes',
      params: defaultAbateParams(),
    });
  },
});
